import CardDashboard from "../../componentes/card/card-dashboard";
import { useState } from "react";
import {
  FaBalanceScale, FaBox, FaCalendar, FaChartBar, FaChartLine, FaClipboardList, FaCubes,
  FaDollarSign, FaFileAlt, FaFileInvoice, FaHandshake, FaHistory, FaIdCard, FaLaptop, FaLocationArrow,
  FaMoneyCheckAlt, FaReceipt, FaRegUser, FaSearch, FaShieldAlt, FaShoppingCart, FaTimes, FaTruck,
} from "react-icons/fa";
import { FaClipboardUser } from "react-icons/fa6";
import { useAuth } from "../../context/authContext";
import LogService from "../../services/resource/logService";

function MainContent() {
  const [searchTerm, setSearchTerm] = useState("");
  const { user } = useAuth();
  const logService = new LogService();

  document.title = "MyDash | Distribuidora York";

  const dashboards = [
    {
      id: "eventos-folhas",
      title: "Eventos de Folhas",
      subtitle: "Relatório Geral sobre eventos das folhas de pagamentos",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Recursos Humanos",
      icon: <FaCalendar />,
      bgColor: "bg-pink-100",
      color: "pink",
      link: "/eventos-folhas",
      allowedProfiles: ["ADMIN", "RH"],
      service: logService,
      user: user,
    },
    {
      id: "meu-bp",
      title: "Meu BP",
      subtitle: "Alteração de valores das minhas contas BP.",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Diretoria",
      icon: <FaDollarSign />,
      link: "/bp/2026",
      bgColor: "bg-indigo-100",
      color: "indigo",
      allowedProfiles: ["ADMIN", "BP"],
      service: logService,
      user: user,
    },
    {
      id: "acompanhamento-logistico",
      title: "Acompanhamento BP",
      subtitle: "Visão detalhada sobre acompanhamento BP das unidades logística e DA da York, com valores do BP x Realizado.",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Contabilidade",
      icon: <FaClipboardList />,
      link: "/acompanhamento-bp",
      bgColor: "bg-blue-100",
      color: "blue",
      allowedProfiles: ["ADMIN", "BP"],
      service: logService,
      user: user,
    },
    {
      id: "solicitacao-compras",
      title: "Solicitação de Compras",
      subtitle: "Acompanhamento das solicitações de compras realizadas pelos usuários no Fluig, destacando localização, status e valores do processo.",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Suprimentos",
      icon: <FaShoppingCart />,
      bgColor: "bg-green-100",
      color: "green",
      link: "/solicitacao-de-compras",
      allowedProfiles: ["ADMIN", "SUPRIMENTOS"],
      service: logService,
      user: user,
    },
    {
      id: "montagem-de-cargas",
      title: "Montagem de Cargas",
      subtitle: "Acompanhamento das montagem de cargas dos distribuidores logístico retirados do sistema EasyPallet.",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Logística",
      icon: <FaBox />,
      bgColor: "bg-red-100",
      color: "red",
      link: "/montagem-de-cargas",
      allowedProfiles: ["ADMIN", "LOGISTICA"],
      service: logService,
      user: user,
    },
    {
      id: "conciliacao-saldos",
      title: "Conciliação de Saldos",
      subtitle: "Relatório de conciliação de saldos contábeis com informações detalhadas de movimentações.",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Contabilidade",
      icon: <FaBalanceScale />,
      bgColor: "bg-indigo-100",
      color: "indigo",
      link: "/conciliacao-de-saldos",
      allowedProfiles: ["ADMIN", "CONTADOR"],
      service: logService,
      user: user,
    },
    {
      id: "pagamento-compensadas",
      title: "Pagamento de Compensadas",
      subtitle: "Importação e calendário de pagamentos compensados por data de compensação.",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Contabilidade",
      icon: <FaMoneyCheckAlt />,
      bgColor: "bg-teal-100",
      color: "teal",
      link: "/pagamento-compensadas",
      allowedProfiles: ["ADMIN", "CONTADOR"],
      service: logService,
      user: user,
    },
    {
      id: "lancamento-despesa",
      title: "Lançamentos de Despesa",
      subtitle: "Visão detalhada dos lançamentos de despesas registradas no Fluig, permitindo acompanhar solicitações e valores.",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Suprimentos",
      icon: <FaReceipt />,
      link: "/lancamento-de-despesa",
      bgColor: "bg-purple-100",
      color: "purple",
      allowedProfiles: ["ADMIN", "SUPRIMENTOS"],
      service: logService,
      user: user,
    },
    {
      id: "prestacao-contas",
      title: "Prestação de Contas",
      subtitle: "Resumo das prestações de contas pendentes e pagas, possibilitando o controle financeiro e monitoramento das obrigações.",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Contabilidade",
      icon: <FaFileInvoice />,
      link: "/prestacao-contas",
      bgColor: "bg-gray-100",
      color: "gray",
      allowedProfiles: ["ADMIN", "CONTADOR"],
      service: logService,
      user: user,
    },
    {
      id: "frota",
      title: "Relatório de Veículos",
      subtitle: "Listagem e relatório de veículos cadastrados no sistema Fleetcom",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Logística",
      icon: <FaTruck />,
      bgColor: "bg-teal-100",
      color: "teal",
      link: "/frota",
      allowedProfiles: ["ADMIN", "LOGISTICA"],
      service: logService,
      user: user,
    },
    {
      id: "notas-veiculos",
      title: "Notas Fiscais de Veículos",
      subtitle: "Visão geral sobre notas fiscais de veículos cadastrado no Fleetcom",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Logística",
      icon: <FaFileAlt />,
      bgColor: "bg-gray-100",
      color: "gray",
      link: "/notas-veiculos",
      allowedProfiles: ["ADMIN", "LOGISTICA"],
      service: logService,
      user: user,
    },
    {
      id: "listagem-funcionarios",
      title: "Listagem de Funcionários",
      subtitle: "Listagem de funcionários ativos/inativos com seus respectivos cargos para consultas simples (Código, Data Admissão e etc).",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Logística",
      icon: <FaIdCard />,
      bgColor: "bg-yellow-100",
      color: "yellow",
      link: "/motoristas",
      allowedProfiles: ["ADMIN", "RH"],
      service: logService,
      user: user,
    },
    {
      id: "comissoes-entrega",
      title: "Comissões de Entregas",
      subtitle: "Relatório de comissões de motoristas e auxiliares de Caxias e distribuidores Logístico",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Logística",
      icon: <FaHandshake />,
      bgColor: "bg-green-100",
      color: "green",
      link: "/comissoes",
      allowedProfiles: ["ADMIN", "RH", "COMISSOES"],
      service: logService,
      user: user,
    },
    {
      id: "escala-de-rotas",
      title: "Escala de Rotas",
      subtitle: "Acompanhamento das escalas de rotas dos motoristas e auxiliares por transporte",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Logística",
      icon: <FaClipboardUser  />,
      bgColor: "bg-yellow-100",
      color: "yellow",
      link: "/escalas-de-rotas",
      allowedProfiles: ["ADMIN", "COMISSOES"],
      service: logService,
      user: user,
    },
    {
      id: "volume-entregue",
      title: "Volume Entregue",
      subtitle: "Acompanhamento de volumes entregues em cubagem",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Logística",
      icon: <FaCubes />,
      bgColor: "bg-red-100",
      color: "red",
      link: "/volume-entregue",
      allowedProfiles: ["ADMIN", "COMISSOES"],
      service: logService,
      user: user,
    },
    {
      id: "rotas-finalizadas",
      title: "Rotas Finalizadas",
      subtitle: "Acompanhamento de rotas, escalas, prazo e imagens",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Logística",
      icon: <FaLocationArrow />,
      bgColor: "bg-green-100",
      color: "green",
      link: "/rotas-finalizadas",
      allowedProfiles: ["ADMIN", "COMISSOES"],
      service: logService,
      user: user,
    },
    {
      id: "entregas-retorno",
      title: "Entregas e Retornos",
      subtitle: "Relatório sobre volumes de entregas e retornos",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Logística",
      icon: <FaChartLine />,
      bgColor: "bg-red-100",
      color: "red",
      link: "/dashboard-entregas-retornos",
      allowedProfiles: ["ADMIN", "COMISSOES", "DIRETOR"],
      service: logService,
      user: user,
    },
    {
      id: "seguranca-viaria",
      title: "Segurança Viária",
      subtitle: "Visão consolidada da segurança na condução viária dos motoristas DL",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Logística",
      icon: <FaShieldAlt />,
      bgColor: "bg-indigo-100",
      color: "indigo",
      link: "/seguranca-viaria",
      allowedProfiles: ["ADMIN", "COMISSOES"],
      service: logService,
      user: user,
    },
    {
      id: "infracoes-caxias",
      title: "Relatório de Infrações - Telemetria Caxias",
      subtitle: "Visão do relatório de infrações da Concept da unidade de Caxias",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Logística",
      icon: <FaShieldAlt />,
      bgColor: "bg-red-100",
      color: "red",
      link: "/infracoes-motoristas/caxias",
      allowedProfiles: ["ADMIN", "COMISSOES-CAXIAS", "RH"],
      service: logService,
      user: user,
    },
    {
      id: "minha-comissao",
      title: "Minha Comissão",
      subtitle: "Visão sobre o valor a receber da comissão",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Logística",
      icon: <FaHandshake />,
      bgColor: "bg-teal-100",
      color: "teal",
      link: "/minha-comissao",
      allowedProfiles: ["ADMIN", "MOTORISTA", "AUXILIAR_ENTREGA"],
      service: logService,
      user: user,
    },
    {
      id: "jornada-trabalho",
      title: "Histórico de Jornada de Trabalho",
      subtitle: "Relatório sobre faltas, bancos de horas, horas devidas sobre as batidas de pontos pelo Solides",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Recursos Humanos",
      icon: <FaHistory />,
      bgColor: "bg-rose-100",
      color: "pink",
      link: "/jornada-trabalhada",
      allowedProfiles: ["ADMIN", "RH"],
      service: logService,
      user: user,
    },
    {
      id: "inventario-ti",
      title: "Inventário de TI",
      subtitle: "Gestão de ativos de TI: computadores, celulares, rede, servidores e periféricos, com movimentações, ciclo de vida e exportação",
      footerRightIcon: <FaRegUser />,
      footerLeftLabel: "Tecnologia da Informação",
      icon: <FaLaptop />,
      bgColor: "bg-teal-100",
      color: "teal",
      link: "/ti/inventario",
      allowedProfiles: ["ADMIN"],
      service: logService,
      user: user,
    },
  ];

  const filteredDashboards = dashboards.filter((d) => {
    const matchesSearch =
      d.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      d.subtitle.toLowerCase().includes(searchTerm.toLowerCase());
    const hasPermission = d.allowedProfiles.some((profile) =>
      user.perfis.includes(profile)
    );
    return matchesSearch && hasPermission;
  });

  return (
    <>
      <style>{`
        .main-content {
          font-family: var(--font-sans), sans-serif;
          flex: 1;
          background: hsl(var(--background));
          min-height: 100vh;
        }

        /* Page header */
        .main-header {
          background: hsl(var(--card));
          border-bottom: 1px solid hsl(var(--border));
          padding: 28px 32px 24px;
        }
        .main-header-inner {
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          flex-wrap: wrap;
          align-items: flex-end;
          justify-content: space-between;
          gap: 16px;
        }
        .main-title-group {}
        .main-eyebrow {
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          color: hsl(var(--primary));
          margin-bottom: 4px;
        }
        .main-title {
          font-family: var(--font-display), sans-serif;
          font-size: 22px;
          font-weight: 700;
          color: hsl(var(--foreground));
          margin: 0;
          line-height: 1.2;
        }
        .main-count {
          font-size: 13px;
          color: hsl(var(--muted-foreground));
          margin-top: 4px;
          font-weight: 400;
        }

        /* Search */
        .search-wrap {
          position: relative;
          width: 260px;
        }
        .search-wrap input {
          width: 100%;
          padding: 9px 14px 9px 38px;
          border: 1px solid hsl(var(--input));
          border-radius: calc(var(--radius) - 2px);
          font-family: var(--font-sans), sans-serif;
          font-size: 13.5px;
          color: hsl(var(--foreground));
          background: hsl(var(--muted));
          outline: none;
          transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
        }
        .search-wrap input:focus {
          border-color: hsl(var(--primary));
          background: hsl(var(--card));
          box-shadow: 0 0 0 3px hsl(var(--primary) / 0.15);
        }
        .search-wrap input::placeholder { color: hsl(var(--muted-foreground)); }
        .search-icon {
          position: absolute;
          left: 12px;
          top: 50%;
          transform: translateY(-50%);
          color: hsl(var(--muted-foreground));
          font-size: 13px;
          pointer-events: none;
        }
        .search-clear {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          cursor: pointer;
          color: hsl(var(--muted-foreground));
          font-size: 11px;
          padding: 2px;
          transition: color 0.15s;
        }
        .search-clear:hover { color: hsl(var(--destructive)); }

        /* Grid */
        .main-grid-wrap {
          max-width: 1400px;
          margin: 0 auto;
          padding: 28px 32px 48px;
        }
        .main-grid {
          display: grid;
          grid-template-columns: repeat(1, 1fr);
          gap: 16px;
        }
        @media (min-width: 640px) {
          .main-grid { grid-template-columns: repeat(2, 1fr); }
        }
        @media (min-width: 1024px) {
          .main-grid { grid-template-columns: repeat(3, 1fr); }
        }
        @media (min-width: 1280px) {
          .main-grid { grid-template-columns: repeat(4, 1fr); }
        }

        /* Empty state */
        .empty-state {
          grid-column: 1 / -1;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 64px 24px;
          color: hsl(var(--muted-foreground));
          gap: 12px;
        }
        .empty-state svg {
          font-size: 36px;
          opacity: 0.35;
        }
        .empty-state p {
          font-size: 14px;
          margin: 0;
        }

        /* Stagger animation for cards */
        .main-grid .card-db:nth-child(1)  { animation-delay: 0.03s; }
        .main-grid .card-db:nth-child(2)  { animation-delay: 0.06s; }
        .main-grid .card-db:nth-child(3)  { animation-delay: 0.09s; }
        .main-grid .card-db:nth-child(4)  { animation-delay: 0.12s; }
        .main-grid .card-db:nth-child(5)  { animation-delay: 0.15s; }
        .main-grid .card-db:nth-child(6)  { animation-delay: 0.18s; }
        .main-grid .card-db:nth-child(7)  { animation-delay: 0.21s; }
        .main-grid .card-db:nth-child(8)  { animation-delay: 0.24s; }
        .main-grid .card-db:nth-child(9)  { animation-delay: 0.27s; }
        .main-grid .card-db:nth-child(10) { animation-delay: 0.30s; }
        .main-grid .card-db:nth-child(11) { animation-delay: 0.33s; }
        .main-grid .card-db:nth-child(12) { animation-delay: 0.36s; }
      `}</style>

      <div className="main-content">
        {/* Header */}
        <div className="main-header">
          <div className="main-header-inner">
            <div className="main-title-group">
              <div className="main-eyebrow">Painel Principal</div>
              <div className="main-count">
                {filteredDashboards.length} relatório{filteredDashboards.length !== 1 ? "s" : ""} disponível{filteredDashboards.length !== 1 ? "is" : ""}
              </div>
            </div>

            <div className="search-wrap">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Buscar relatório..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button className="search-clear" onClick={() => setSearchTerm("")}>
                  <FaTimes />
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Cards grid */}
        <div className="main-grid-wrap">
          <div className="main-grid" id="reports-list">
            {filteredDashboards.length > 0 ? (
              filteredDashboards.map((d) => (
                <CardDashboard key={d.id} {...d} />
              ))
            ) : (
              <div className="empty-state">
                <FaChartBar />
                <p>Nenhum relatório encontrado para "<strong>{searchTerm}</strong>"</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default MainContent;
